import { type ServiceAddress } from 'utils/hooks/types'

export interface ConsolidatedAddress {
    isAdminLinked?: boolean
    accountId: string
    legacyAcctNumber: string
    serviceAddresses: Array<{
        premiseId: string
        serviceAddress: string
    }>
}

export const consolidateServiceAddresses = (serviceAddresses: ServiceAddress[]): ConsolidatedAddress[] => {
    const consolidatedMap: Record<string, ConsolidatedAddress | undefined> = {}

    serviceAddresses.forEach(item => {
        const { accountId, legacyAcctNumber, premiseId, serviceAddress, isAdminLinked } = item
        const key = `${accountId}-${legacyAcctNumber}`

        if (consolidatedMap[key] == null) {
            consolidatedMap[key] = {
                accountId,
                legacyAcctNumber,
                serviceAddresses: [],
                isAdminLinked
            }
        }


        if (consolidatedMap[key] != null) {
            const serviceExists = consolidatedMap[key]?.serviceAddresses.some(
                address => address.premiseId === premiseId
            )

            if (serviceExists === false) {
                consolidatedMap[key]?.serviceAddresses.push({ premiseId, serviceAddress })
            }
        }
    })

    return Object.values(consolidatedMap).filter(Boolean) as ConsolidatedAddress[]
}
